import {alertActions} from '.';
import {empresaConstants} from '../_constants/empresa.constants';
import {empresaService} from '../_services/empresa.service';

export const empresaActions = {
    traerEmpresas,
    grabar,
    asignarUsuarioAEmpresa
};

function traerEmpresas() {
    return dispatch => {
        empresaService.traerEmpresas()
            .then(
                data => {
                    dispatch(success(data));
                },
                error => dispatch(alertActions.error(error))
            );
    };

    function success(data) {
        return {type: empresaConstants.TRAER_EMPRESAS, data}
    }
}

function grabar(empresa, handleClose, setGrabando) {
    setGrabando(true);
    return dispatch => {
        empresaService.grabar(empresa)
            .then(
                data => {
                    setGrabando(false);
                    if (empresa.id === undefined) {
                        dispatch(success(data));
                    } else {
                        dispatch(successAct(data));
                    }

                    handleClose();
                },
                error => {
                    setGrabando(false);
                    dispatch(alertActions.error(error));
                }
            );
    };

    function successAct(data) {
        return {type: empresaConstants.ACT_EMPRESA, data}
    }

    function success(data) {
        return {type: empresaConstants.AGREGAR_EMPRESA, data}
    }
}

function asignarUsuarioAEmpresa(datos, handleClose, setGrabando) {
    setGrabando(true);
    return dispatch => {
        empresaService.asignarUsuarioAEmpresa(datos)
            .then(
                data => {
                    setGrabando(false);
                    handleClose();
                },
                error => {
                    setGrabando(false);
                    dispatch(alertActions.error(error));
                }
            );
    };
}


